import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { roLocale } from 'ngx-bootstrap/locale'; // ⬅️ Импортируем локаль!
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ToastComponent } from './pages/shared/toast/component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TooltipModule, ToastComponent],
  template: `
    <router-outlet />
    <app-toast />
  `,
})
export class App {
  private readonly localeService = inject(BsLocaleService);
  private readonly titleService = inject(Title);
  private readonly translateService = inject(TranslateService);

  constructor() {
    defineLocale('ro', roLocale); // ⬅️ Передаём локаль
    this.localeService.use('ro'); // ⬅️ Устанавливаем язык

    this.translateService.onLangChange.subscribe(() => {
      this.translateService.get('HEAD.TITLE').subscribe((txt) => {
        this.titleService.setTitle(txt);
      });
    });
  }
}
